import { ICountry } from 'shared/types/Country';
import { apiSlice } from 'store/api/apiSlice';

interface IFetchCountriesResponse {
  countries: ICountry[];
}

// Create a new api by injecting endpoints into the root api slice
// Ref: https://redux-toolkit.js.org/rtk-query/usage/code-splitting
export const countriesApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    fetchCountries: builder.query<IFetchCountriesResponse, void>({
      query: () => ({
        url: '/web-api/v1/countries',
        method: 'GET',
      }),
    }),
  }),
});

export const { useFetchCountriesQuery: useCountriesQuery } = countriesApi;
